import request from '../utils/request';
//获取地址
export function codeListBySpotId(data) {
  return request({
    url: 'trainClass/codeListBySpotId.html',
    method: 'get',
    params:data,
  })
}

//上传图片
export function upload(data) {
  return request({
    url: 'common/upload',
    method: 'post',
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data,
  })
}

//获取学历
export function getEducationList(data) {
  return request({
    url: 'trainClass/getEducationList.do',
    method: 'get',
    params:data,
  })
}

//获取培训科目
export function codeListByParent(data) {
  return request({
    url: 'trainClass/codeListByParent.do',
    method: 'get',
    params:data,
  })
}

//查询是否已购买过改课程
export function getClassListBySubject(data) {
  return request({
    url: 'trainClass/getClassListBySubject',
    method: 'get',
    params:data,
    skipInterceptor: true  // 添加跳过拦截器的标记
  })
}


//报名
export function toGenerateOrder(data) {
  return request({
    url: 'order/toGenerateOrder.do',
    method: 'post',
    data,
  })
}


//支付宝支付
export function payEnd(data) {
  return request({
    url: 'order/payEnd.do',
    method: 'post',
    data,
  })
}

//支付宝对账
export function toTradeQueryZFB(data) {
  return request({
    url: 'order/toTradeQueryZFB.do',
    method: 'post',
    data,
  })
}

//获取订单信息
export function toOrderCancelTime(data) {
  return request({
    url: 'order/toOrderCancelTime.do',
    method: 'post',
    data,
  })
}

//分类搜索
export function search(data) {
  return request({
    url: 'trainClass/Search.html',
    method: 'get',
    params:data,
  })
}

//支付成功
export function toPaySuccess(data) {
  return request({
    url: 'order/toPaySuccess.do',
    method: 'post',
    data,
  })
}

//承诺书截图
export function screenshot(data) {
  return request({
    url: 'userData/screenshot.html',
    method: 'get',
    params:data,
  })
}

